import { SeoModel } from '../../models';

export type HeadSocialMetaModel = {
  seo?: SeoModel;
};

export enum MetaSocialTags {
  card = 'twitter:card',
  title = 'twitter:title',
  description = 'twitter:description',
  image = 'twitter:image',
  vkImage = 'vk:image',
}
